import React from 'react';
import Select from 'react-select';

import CriteriaComponentCount from './CriteriaComponentCount';
import OrganizationApi from '../../api/organization';
import PracticeApi from '../../api/practice';
import ManagePlanCriterion from './ManagePlanCriterion';
import CriteriaPlanGroup from './CriteriaPlanGroup';
import Subnav from '../subnav';
import { CSVLink } from 'react-csv';
import Button from '../form/Button';
import _ from 'lodash';
import { statusColumns } from '../../utils';

import withEhsPageBehavior from '../../withEhsPageBehavior';

const SORT_OPTIONS = [
  {
    label: 'Default',
    value: 'code',
  },
  {
    label: 'Check-in',
    value: 'checkin',
  },
  {
    label: 'Number of Components',
    value: 'minimum_components',
  },
];

const prevalidatedKey = 'Prevalidated';

class ManagePlanPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      criteria: [],
      practice: null,
      organization: null,
      filterOn: '',
      sortOn: 'code',
      groupCounts: null,
    };

    this.onFilterChange = this.onFilterChange.bind(this);
    this.sortCriteria = this.sortCriteria.bind(this);
    this.generateStats = this.generateStats.bind(this);
    this.fetchCriteria = this.fetchCriteria.bind(this);
    this.getCSVFilePath = this.getCSVFilePath.bind(this);
    this.generateRows = this.generateRows.bind(this);
    this.generateColumns = this.generateColumns.bind(this);
  }

  componentWillMount() {
    const organizationId = this.props.match.params.organizationId;

    // Update the organization stats.
    OrganizationApi.get(organizationId).then(org => {
      this.setState({
        organization: org,
      });
    });
    this.fetchCriteria();
  }

  async fetchPractice(practiceId) {
    try {
      return await PracticeApi.get(practiceId);
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  fetchCriteria() {
    // Get the criteria for the primary practice and use that as our plan
    const organizationId = this.props.match.params.organizationId;

    // Update the criteria list.
    OrganizationApi.getPlan(organizationId).then(async criteria => {
      let practice = null;

      // Try to get the practice.
      if (criteria.length > 0) {
        const practiceId = criteria[0].practice_id;
        if (practiceId) {
          try {
            practice = await this.fetchPractice(practiceId);
          } catch (error) {
            console.log(error);
          }
        }
      }

      this.countGroups(criteria);
      this.setState({
        practice,
        criteria: criteria,
      });
    });
  }

  onFilterChange(evt) {
    let filterVal = evt.target.value;
    this.setState({
      filterOn: filterVal,
    });
  }

  filterCriteria(criteria) {
    if (!this.state.filterOn) {
      return criteria;
    }

    let f = this.state.filterOn.toLowerCase();
    let result = criteria.filter(criterion => {
      // type
      if (criterion.type.toLowerCase().indexOf(f) >= 0) {
        return true;
      }
      // criterion code
      else if (criterion.code.toLowerCase().indexOf(f) >= 0) {
        return true;
      }
      // concept
      else if (criterion.concept_code.toLowerCase().indexOf(f) >= 0 || criterion.concept.toLowerCase().indexOf(f) >= 0) {
        return true;
      }
      // competency
      else if (criterion.competency_code.toLowerCase().indexOf(f) >= 0 || criterion.competency.toLowerCase().indexOf(f) >= 0) {
        return true;
      }
      // description
      else if (criterion.description.toLowerCase().indexOf(f) >= 0) {
        return true;
      }
      return false;
    });
    return result;
  }

  sortCriteria(criteria) {
    const defaultSort = (a, b) => {
      const a1 = a.order;
      const b1 = b.order;
      const a2 = a.code.toLowerCase();
      const b2 = b.code.toLowerCase();
      if (a1 < b1) return -1;
      if (a1 > b1) return 1;
      if (a2 < b2) return -1;
      if (a2 > b2) return 1;
      return 0;
    };

    if (this.state.sortOn === 'minimum_components' || this.state.sortOn === 'credits') {
      // sort descending
      criteria.sort((a, b) => {
        let sortResult = b[this.state.sortOn] - a[this.state.sortOn];
        if (sortResult === 0) {
          sortResult = defaultSort(a, b);
        }
        return sortResult;
      });
    } else if (this.state.sortOn === 'code') {
      // Sort alphabetically by code.
      criteria.sort((a, b) => {
        let sortResult = 0;

        if (a[this.state.sortOn] < b[this.state.sortOn]) {
          sortResult = -1;
        } else if (a[this.state.sortOn] > b[this.state.sortOn]) {
          sortResult = 1;
        } else sortResult = 0;

        return sortResult;
      });
    } else {
      criteria.sort((a, b) => {
        let sortResult = a[this.state.sortOn] - b[this.state.sortOn];
        if (sortResult === 0) {
          sortResult = defaultSort(a, b);
        }
        return sortResult;
      });
    }
  }

  generateStats() {
    let stats = {
      1: {
        min: 1,
        max: 90,
        range: 100,
        count: 0,
        core: 0,
        elective: 0,
        prevalidated: 0,
      },
      2: {
        min: 0,
        max: 90,
        range: 100,
        count: 0,
        core: 0,
        elective: 0,
      },
      3: {
        min: 0,
        max: 90,
        range: 100,
        count: 0,
        core: 0,
        elective: 0,
      },
      unplanned: {
        components: 0,
        count: 0,
        core: 0,
        elective: 0,
      },
      electives: {
        count: 0,
        target: 25,
      },
      prevalidated: {
        count: 0,
      },
      concepts: {
        count: 0,
        target: 5,
      },
    };
    let criterionGroups = {};
    let concepts = [];
    let log = {};

    this.state.criteria.forEach(criterionRaw => {
      let criterion = _.cloneDeep(criterionRaw);
      _.set(log, `${criterion.code}`, {
        self_credits: criterion.credits,
        self_components: criterion.minimum_components,
        max_credits: criterion.maximum_credits,
        max_components: criterion.maximum_components,
        type: criterion.type.toLowerCase().replace(/ /g, ''),
      });

      let isFirst = false;

      if (criterion.status === 'Disabled') {
        return;
      }

      // If the criterion is part of a group, check if the group is being tracked.
      // Create the group if its not there with the defaults, otherwise continue the talley
      // Looking specifically at max credits and components the group as a whole is worth
      if (_.has(criterion, 'parent_code') && criterion.parent_code != null) {
        if (_.has(criterionGroups, `${criterion.parent_code}`)) {
          criterionGroups[`${criterion.parent_code}`].currentlyChecked++;
          criterionGroups[`${criterion.parent_code}`].currentCredits += criterion.credits;
          criterionGroups[`${criterion.parent_code}`].currentComponents += criterion.minimum_components;
        } else {
          const groupInfo = {
            maxComponents: criterion.maximum_components,
            maxCredits: criterion.maximum_credits,
            minimumChecked: criterion.grouping,
            currentlyChecked: 1,
            currentCredits: criterion.credits,
            currentComponents: criterion.minimum_components,
          };

          isFirst = true;
          _.set(criterionGroups, `${criterion.parent_code}`, groupInfo);
        }
        const compare = criterionGroups[`${criterion.parent_code}`];

        log[criterion.code].group_current_credits = compare.currentCredits;
        log[criterion.code].group_current_components = compare.currentComponents;

        // Check if we have gone over the max for credits or components in the group
        // If we went over, get the difference (encase its worth 2 but we only need 1)
        // If the difference is a negative number, make it 0 - we don't want to ever subtract
        if (criterion.maximum_credits !== null && compare.currentCredits > compare.maxCredits) {
          log[criterion.code].was_max_credits = true;
          criterion.credits = compare.maxCredits - compare.currentCredits;
          if (Math.sign(criterion.credits) < 0) {
            criterion.credits = 0;
          }
        }
        if (compare.maximum_components !== 0 && compare.currentComponents > compare.maxComponents) {
          criterion.minimum_components = compare.maxComponents - compare.currentComponents;
          if (Math.sign(criterion.minimum_components) < 0) {
            criterion.minimum_components = 0;
          }
          log[criterion.code].was_max_components = true;
        }
      }

      let checkin = criterion.checkin;

      if (criterion.minimum_components) {
        if ((checkin !== 'unplanned' || checkin !== null) && criterion.status.toLowerCase() !== 'prevalidated') {
          // && criterion.status.toLowerCase() !== 'prevalidated' - Took this out as instructed, may need it if client changes mind.
          if (checkin) {
            stats[checkin].count += criterion.minimum_components;
            log[criterion.code].global_component_count = stats[checkin].count;

            let type = criterion.type.toLowerCase().replace(/ /g, '');

            if (isFirst || !_.has(criterion.grouping)) {
              if (type === 'nysrequired') {
                stats[checkin]['elective']++;
              }

              stats[checkin][type]++;
              log[criterion.code].hit_critGroup = true;
            }
          }
        }
      }

      let critType = criterion.type.toLowerCase().replace(/ /g, '');

      if ((critType === 'elective' || critType === 'nysrequired') && checkin !== 'unplanned' && checkin !== null && criterion.credits > 0) {
        stats.electives.count += criterion.credits ? criterion.credits : 0;
        log[criterion.code].hit_section_1 = true;
      }

      if (criterion.status.toLowerCase() === 'prevalidated') {
        stats[checkin].prevalidated++;
        stats.prevalidated.count++;
        log[criterion.code].hit_section_2 = true;
      }

      // If the selection is set to "Unplanned", we send null the api. See ManagePlanCriterion.js
      // Include null values in the unplanned count.
      if (checkin === 'unplanned' || checkin === null) {
        if (criterion.minimum_components) {
          stats.unplanned.components += criterion.minimum_components;
          log[criterion.code].hit_section_3 = true;
        }
        stats.unplanned.count++;
      }

      if ((critType === 'elective' || critType === 'nysrequired') && checkin !== 'unplanned' && concepts.indexOf(criterion.concept_code) < 0) {
        concepts.push(criterion.concept_code);
        log[criterion.code].hit_section_4 = true;
      }
    });

    let newLog = {};

    for (let [key, value] of Object.entries(log)) {
      newLog[value.global_component_count] = { [key]: value };
    }

    console.log(newLog);

    stats.concepts.count = concepts.length;
    return stats;
  }

  countGroups = criteria => {
    if (this.state.groupCounts !== null) {
      return;
    }
    let groups = {};
    criteria.map(criterion => {
      if (_.has(groups, `${criterion.parent_code}`)) {
        groups[`${criterion.parent_code}`].count++;
      } else {
        _.set(groups, `${criterion.parent_code}.count`, 1);
        _.set(groups, `${criterion.parent_code}.required`, criterion.grouping);
        _.set(groups, `${criterion.parent_code}.currentActive`, 0);
      }
      if (criterion.status !== 'Disabled') {
        groups[`${criterion.parent_code}`].currentActive++;
      }
      return null;
    }, groups);
    this.setState({ groupCounts: groups });
  };

  updateGroups = (id, currentActive) => {
    let newState = this.state.groupCounts;
    _.set(newState, `${id}.currentActive`, newState[id].currentActive + currentActive);
    this.setState({ groupCounts: newState });
  };

  renderCriterion = criteria => {
    let group = [];

    return criteria.map(criterion => {
      if (criterion.grouping === null) {
        return <ManagePlanCriterion key={criterion.id} criterion={criterion} onUpdate={this.fetchCriteria} excerpt={false} />;
      } else {
        if (_.indexOf(group, criterion.parent_code) < 0) {
          group.push(criterion.parent_code);
          return (
            <div>
              <CriteriaPlanGroup criterion={criterion} count={this.state.groupCounts[criterion.parent_code]} />
              <ManagePlanCriterion key={criterion.id} criterion={criterion} onUpdate={this.fetchCriteria} excerpt={true} updateCounts={this.updateGroups} />
            </div>
          );
        } else {
          return <ManagePlanCriterion key={criterion.id} criterion={criterion} onUpdate={this.fetchCriteria} excerpt={true} updateCounts={this.updateGroups} />;
        }
      }
    });
  };

  generateColumns = () => {
    return [
      ...statusColumns,
      { label: prevalidatedKey, key: 'prevalidated' },
    ];
  };

  generateRows = () => {
    // If the checkin is null, set it as unplanned.
    return this.state.criteria.map(criterion => ({
      id: criterion.id,
      checkin: criterion.checkin ? criterion.checkin : 'Unplanned',
      code: criterion.code,
      competency: criterion.competency,
      concept: criterion.concept,
      description: criterion.description,
      scope: criterion.scope,
      type: criterion.type,
      prevalidated: criterion.status === prevalidatedKey ? 'Yes' : 'No',
    }));
  };

  getCSVFilePath() {
    let filePath = `Plan Page.csv`;

    if (this.state.organization && this.state.practice) {
      filePath = `${this.state.organization.name}_${this.state.practice.name}_${filePath}.csv`.replace(
        / /g,
        '-'
      );
    }

    return filePath;
  }

  render() {
    const stats = this.generateStats();
    const organization = this.state.organization;
    //let orgName = 'Loading';
    let orgId = null;
    if (organization) {
      //orgName = organization.name;
      orgId = organization.id;
    }

    let criteria = this.filterCriteria(this.state.criteria);
    this.sortCriteria(criteria);

    let filterCountMessage = (
      <div className="filterCountMessage">
        <p>{criteria.length} criteria</p>
      </div>
    );
    if (this.state.filterOn) {
      filterCountMessage = (
        <div className="filterCountMessage">
          <p>
            {criteria.length} of {this.state.criteria.length} criteria shown.
          </p>
        </div>
      );
    }

    return (
      <main className="page">
        <div className="page__subnav">
          <Subnav organizationId={orgId} />
        </div>
        <div className="page__header SetupCriteriaHeader">
          <h2>
            <i className="fa fa-cogs" /> Primary Practice Plan
          </h2>
          <div className="row">
            <div className="column">
              <CriteriaComponentCount name="Check-in #1" checkin={stats[1]} checkinNumber={1} org={organization} />
            </div>
            <div className="column">
              <CriteriaComponentCount name="Check-in #2" checkin={stats[2]} checkinNumber={2} org={organization} />
            </div>
            <div className="column">
              <CriteriaComponentCount name="Check-in #3" checkin={stats[3]} checkinNumber={3} org={organization} />
            </div>
          </div>
          <div className="ElectiveMetrics">
            <div className="ElectiveMetric">
              <strong> Overall Elective Credits</strong>: {Math.ceil(stats.electives.count)} / {stats.electives.target}
            </div>
            <div className="ElectiveMetric">
              <strong> Overall Elective Concepts</strong>: {stats.concepts.count} / {stats.concepts.target}
            </div>
            <div className="ElectiveMetric">
              <strong> Unplanned </strong>: {stats.unplanned.components} Components ({stats.unplanned.count} Criteria)
            </div>
          </div>
        </div>
        <div className="sidebarpage">
          <div className="sidebarpage__content">
            <div className="SetupCriteriaTable">{this.renderCriterion(criteria)}</div>
          </div>
          <div className="sidebarpage__sidebar">
            <div className="CriteriaFilter">
              <div className="CFContainer">
                <label>Filter: </label>
                <input type="text" name="filterOn" value={this.state.filterOn} onChange={this.onFilterChange} />
              </div>
              <div className="CFContainer">
                <label>Sort By: </label>
                <Select
                  name="sortOn"
                  options={SORT_OPTIONS}
                  value={this.state.sortOn}
                  onChange={newSort => {
                    this.setState({
                      sortOn: newSort.value,
                    });
                  }}
                  clearable={false}
                  searchable={false}
                />
              </div>
              {filterCountMessage}
              <CSVLink
                target="_self"
                filename={this.getCSVFilePath()}
                data={this.generateRows()}
                headers={this.generateColumns()}>
                <Button icon="fa fa-download" defaultText="Download CSV" />
              </CSVLink>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default withEhsPageBehavior(ManagePlanPage);
